/**
 * Service pour les bénéficiaires
 */

import api from './api.js';

/**
 * Créer un bénéficiaire
 */
export async function createBeneficiaire(beneficiaireData) {
  const response = await api.post('/beneficiaires', beneficiaireData);
  return response.data;
}

/**
 * Obtenir un bénéficiaire par ID
 */
export async function getBeneficiaireById(beneficiaireId) {
  const response = await api.get(`/beneficiaires/${beneficiaireId}`);
  return response.data;
}

/**
 * Mettre à jour un bénéficiaire
 */
export async function updateBeneficiaire(beneficiaireId, updates) {
  const response = await api.put(`/beneficiaires/${beneficiaireId}`, updates);
  return response.data;
}

/**
 * Marquer comme inscrit (gouverneur/admin seulement)
 */
export async function markAsInscrit(beneficiaireId) {
  const response = await api.post(`/beneficiaires/${beneficiaireId}/mark-inscrit`);
  return response.data;
}

/**
 * Lister les bénéficiaires
 */
export async function listBeneficiaires(filters = {}) {
  const params = new URLSearchParams();
  if (filters.relais_id) params.append('relais_id', filters.relais_id);
  if (filters.statut_couleur) params.append('statut_couleur', filters.statut_couleur);
  if (filters.carte_pastef_statut) params.append('carte_pastef_statut', filters.carte_pastef_statut);
  if (filters.type_suivi_electoral) params.append('type_suivi_electoral', filters.type_suivi_electoral);
  if (filters.localite_id) params.append('localite_id', filters.localite_id);
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);
  
  const response = await api.get(`/beneficiaires?${params.toString()}`);
  return response.data;
}

/**
 * Rechercher des bénéficiaires
 */
export async function searchBeneficiaires(searchTerm, limit = 50) {
  const response = await api.get(`/beneficiaires/search?q=${encodeURIComponent(searchTerm)}&limit=${limit}`);
  return response.data;
}

/**
 * Obtenir les statistiques d'un bénéficiaire
 */
export async function getBeneficiaireStats(beneficiaireId) {
  const response = await api.get(`/beneficiaires/${beneficiaireId}/stats`);
  return response.data;
}

/**
 * Obtenir les documents d'un bénéficiaire (justificatifs + preuve carte électorale)
 */
export async function getDocumentsForBeneficiaire(beneficiaireId) {
  const response = await api.get(`/beneficiaires/${beneficiaireId}/documents`);
  return response.data;
}

/**
 * Upload preuve de la carte électorale (inscription)
 */
export async function uploadInscriptionProof(beneficiaireId, etapeId, file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('etapeId', etapeId);
  const response = await api.post(`/beneficiaires/${beneficiaireId}/inscription-proof`, formData);
  return response.data;
}
